import React from 'react';
import { StepConfiguration, StepID } from './types';

const PRICE = '24,99 €';
const STEP_CONFIGURATION = new Map<StepID, StepConfiguration>([
  [
    'awareness',
    {
      title: 'Chiudi più affari con il badge "profilo verificato"',
      illustration: 'verified-user.svg',
      description: (
        <>
          Verifica il tuo profilo a soli <b>{PRICE} l'anno</b> e otterrai un
          badge che sarà visibile sia sul tuo <b>profilo</b> che sui tuoi{' '}
          <b>annunci</b>. In più, gli acquirenti potranno filtrare i risultati
          per vedere solo gli annunci di utenti verificati.
        </>
      ),
      nextAction: { label: 'Ottieni il badge', objectID: 'awareness_accept' },
      rejectAction: { label: 'Non mi interessa', objectID: 'awareness_reject' },
      next: 'purchase',
    },
  ],
  [
    'purchase',
    {
      title: 'Acquista "Profilo verificato" e inserisci i tuoi dati',
      description: (
        <>
          Dopo il pagamento, ti verranno richiesti i seguenti dati:
          <ul>
            <li>Nome e cognome</li>
            <li>Codice Fiscale</li>
            <li>Numero carta d'identità</li>
            <li>Video selfie con carta d'identità in mano</li>
          </ul>
          Una volta completato il form, la verifica richiederà fino a tre giorni
          lavorativi. Al termine, il badge comparirà automaticamente sul tuo
          profilo e su tutti i tuoi annunci.
        </>
      ),
      nextAction: {
        label: `Verifica il profilo a ${PRICE}`,
        objectID: 'purchase_accept',
      },
      rejectAction: {
        label: 'Ricordamelo più tardi',
        objectID: 'purchase_later',
      },
      next: 'typ',
    },
  ],
  [
    'typ',
    {
      title: "Grazie per l'interesse",
      illustration: 'fake-door.webp',
      description: (
        <>
          Il servizio non è ancora attivo, ma ci stiamo lavorando. Ti
          aggiorneremo quando sarà disponibile.
        </>
      ),
      nextAction: {
        label: 'Ok, ho capito',
        objectID: 'typ_ack',
      },
    },
  ],
]);

export { STEP_CONFIGURATION };
